import {BlockType} from '../../../constants/BlockType';
import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {ButtonBuiltInControl} from '../ButtonBuiltInControl';

import {ButtonBorderRadiusControlLabels} from './ButtonBorderRadiusControlLabels';

export abstract class ButtonBorderRadiusBuiltInControl extends ButtonBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes[BlockType.BLOCK_BUTTON].BORDER_RADIUS;
  }

  public getLabels(): ButtonBorderRadiusControlLabels | undefined {
    return undefined;
  }
}
